import { algorithms } from '@helpers/types.ts';
import { Help, LocationOff, MapOutlined } from '@mui/icons-material';
import { Tooltip } from '@mui/material';

export const AlgorithmLabel = ({ algorithm }: { algorithm: algorithms }) => {
  switch (algorithm) {
    case algorithms.k_means:
      return (
        <Tooltip title="Probabilístico">
          <LocationOff />
        </Tooltip>
      );
    case algorithms.or_tools:
      return (
        <Tooltip title="Simulación">
          <MapOutlined />
        </Tooltip>
      );
    default:
      return <Help />;
  }
};
